import { archives } from '@saucelabs/sl-util-axios';

export const jobs = (params) => (
  archives.get('/rdc/jobs', { params })
);
